<template>
  <div class="container">
    <div class="top-subcontainer">
      <input v-model="searchValue" type="text" :placeholder="'Search'" />
      <img src="../assets/SearchIconGrey.svg" />
    </div>
    <div class="bottom-subcontainer">
      <div
        v-for="thing of filteredThings"
        :key="'filter-list-' + thing"
        :value="thing"
        class="item-row"
        @click="$emit('displayVariable', thing)"
      >
        <span class="item-icon"><img src="../assets/document.svg" /></span>
        <div class="row">{{ addUnderScore(thing) }}</div>
        <div class="item-title row">{{ thing }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    searchThing: {
      type: String,
      default: () => {
        return 'thing'
      }
    },
    things: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data() {
    return {
      searchValue: ''
    }
  },

  computed: {
    filteredThings() {
      if (!this.searchValue) return this.things
      const regex = new RegExp(this.searchValue, 'gi')
      const filtered = []
      for (const thing of this.things) {
        if (thing.toLowerCase().match(regex)) filtered.push(thing)
      }
      if (filtered.length < 1) return this.things
      return filtered
    }
  },

  methods: {
    addUnderScore(thing) {
      let newThing = thing.split(' ')
      newThing = '{{' + newThing[0] + '_' + newThing[1] + '}}'
      return newThing
    }
  }
}
</script>

<style scoped>
.container {
  background: white;
  border: 0.5px solid #dfdfdf;
  box-sizing: border-box;
  border-radius: 4px;
  z-index: 1;
  height: 380px;
}

.bottom-subcontainer {
  max-height: 350px;
  overflow-y: scroll;
  position: relative;
}

.top-subcontainer {
  position: relative;
  padding: 16px;
  min-width: 100px;
  min-height: 32px;
}

.top-subcontainer input {
  border: 1px solid #dfdfdf;
  box-sizing: border-box;
  border-radius: 5px;
  width: 90%;
  height: 32px;
  padding-left: 20px;
}
.top-subcontainer img {
  position: absolute;
  right: 20px;
  top: 28px;
}

input:focus,
textarea:focus,
select:focus {
  outline: none;
}

.item-row {
  cursor: pointer;
  margin-left: 30px;
  position: relative;
}

.item-icon {
  position: absolute;
  top: 10px;
  left: -15px;
}

.row {
  display: flex;
  flex-direction: row;
  padding: 3px;
  justify-content: start;
}

.item-title {
  font-family: Montserrat;
  font-style: normal;
  font-weight: normal;
  font-size: 11px;
  line-height: 13px;
  display: flex;
  color: #4a4a4a;
  text-transform: capitalize;
}
</style>
